import { selectArray } from 'redux-most';
import { switchMap, fromFuture } from 'most-adjunct';
import * as mostc from '../../../crosscutting/mostc';
import * as most from 'most';
import * as r from 'ramda';
import * as signals from '../../signals';
import * as messages from '../../../domain/messages';

export const dismissRibbonEpic = (actions) => r.pipe(
  selectArray([
    messages.OPTED_IN,
    messages.OPTED_OUT,
  ]),
  mostc.map(() => {
    return messages.ribbonDissmissed();
  }),
)(actions);


// WEBPACK FOOTER //
// ./src/application/epics/privacy/ribbon.js